import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";


export const loadCategories = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('categories/collection').then((response) => {
            commit(types.ADD_CATEGORIES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createCategory = ({commit, dispatch, state}, data) => {

    let formData = new FormData();
    formData.append('name', data.name);
    formData.append('image', data.image);
    formData.append('online', data.online);
    if (data.parent_id !== null) {
        formData.append('parent_id', data.parent_id);
    }

    formData.append('_method', 'POST');

    return new Promise((resolve, reject) => {
        window.axios.post('store/category', formData, data, {headers: {'Content-type': 'multipart/form-data'}}).then((response) => {
            resolve(response)
            commit(types.ADD_CATEGORY, response.data.category)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateCategory = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/category', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteCategory = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/category').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setVisibleCategory = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('setVisible/' + data.id +'/category', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const uploadImage = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('category/upload-image', data).then((response) => {
            commit(types.SET_IMAGE, { id: response.data.id, image: response.data.image })
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
